export const ExperimentTitleNames = {
  ArticleAdDensity: "Article Ad Density",
  ContextualPaywallMessaging: "Contextual Paywall Messaging",
  HigherPaywall: "Higher Paywall",
  LTSHardPaywall: "LTS 70 Hard Paywall",
  NewSearchBackend: "New Search Backend",
  PaywallMasking: "Paywall Masking",
  VelocityWallThreshold: "Velocity Wall Threshold",
};

export const ExperimentAPINames = {
  ArticleAdDensity: "article_ad_density",
};
